import { Lexeme, LexemeType } from '.';

export default class Lexer {
  private text: string;
  private index: number;

  constructor(text: string) {
    this.text = text;
    this.index = 0;
    (window as any).Lexer = Lexer;
  }

  getLexeme(): Lexeme {
    const lexeme: Lexeme = {
      type: LexemeType.TEXT,
      token: ''
    };
    let ch: string;
    let state = 1;

    while (state !== 23) {
      ch = this.getChar();
      switch (state) {
        case 1:
          if (ch === '*') {
            lexeme.token += ch;
            state = 2;
          } else if (ch === '_' ) {
            lexeme.token += ch;
            state = 7;
          } else if (ch === '~' ) {
            lexeme.token += ch;
            state = 12;
          } else if (ch === '`' ) {
            lexeme.token += ch;
            state = 17;
          } else {
            lexeme.token += ch;
            state = 22;
          }
          break;
        case 2:
          if (ch === '*') {
            lexeme.token += ch;
            state = 3;
          } else if (this.isEOL(ch)) {
            lexeme.token += ch;
            state = 23;
          } else {
            lexeme.token += ch;
          }
          break;
        case 3:
          if (ch === '*') {
            lexeme.token += ch;
            state = 4;
          } else if (this.isBlank(ch)) {
            lexeme.type = LexemeType.BOLD;
            if (ch) {
              this.ungetChar();
            }
            state = 23;
          } else {
            lexeme.token += ch;
            state = 5;
          }
          break;
        case 4:
          if (ch === '*') {
            lexeme.token += ch;
          } else {
            state = 23;
            if (ch) {
              this.ungetChar();
            }
          }
          break;
        case 5:
          if (ch === '*') {
            lexeme.token += ch;
            state = 6;
          } else if (this.isEOL(ch)) {
            state = 23;
          } else {
            lexeme.token += ch;
          }
          break;
        case 6:
          if (this.isWord(ch)) {
            lexeme.token += ch;
            state = 5;
          } else {
            lexeme.type = LexemeType.BOLD;
            if (ch) {
              this.ungetChar();
            }
            state = 23;
          }
          break;
        case 7:
          if (ch === '_') {
            lexeme.token += ch;
            state = 8;
          } else if (this.isEOL(ch)) {
            lexeme.token += ch;
            state = 23;
          } else {
            lexeme.token += ch;
          }
          break;
        case 8:
          if (ch === '_') {
            lexeme.token += ch;
            state = 9;
          } else if (this.isBlank(ch)) {
            lexeme.type = LexemeType.ITALIC;
            if (ch) {
              this.ungetChar();
            }
            state = 23;
          } else {
            lexeme.token += ch;
            state = 10;
          }
          break;
        case 9:
          if (ch === '_') {
            lexeme.token += ch;
          } else {
            state = 23;
            if (ch) {
              this.ungetChar();
            }
          }
          break;
        case 10:
          if (ch === '_') {
            lexeme.token += ch;
            state = 11;
          } else if (this.isEOL(ch)) {
            state = 23;
          } else {
            lexeme.token += ch;
          }
          break;
        case 11:
          if (this.isWord(ch)) {
            lexeme.token += ch;
            state = 10;
          } else {
            lexeme.type = LexemeType.ITALIC;
            if (ch) {
              this.ungetChar();
            }
            state = 23;
          }
          break;
        case 12:
          if (ch === '~') {
            lexeme.token += ch;
            state = 13;
          } else if (this.isEOL(ch)) {
            lexeme.token += ch;
            state = 23;
          } else {
            lexeme.token += ch;
          }
          break;
        case 13:
          if (ch === '~') {
            lexeme.token += ch;
            state = 14;
          } else if (this.isBlank(ch)) {
            lexeme.type = LexemeType.DASHED;
            if (ch) {
              this.ungetChar();
            }
            state = 23;
          } else {
            lexeme.token += ch;
            state = 15;
          }
          break;
        case 14:
          if (ch === '~') {
            lexeme.token += ch;
          } else {
            state = 23;
            if (ch) {
              this.ungetChar();
            }
          }
          break;
        case 15:
          if (ch === '~') {
            lexeme.token += ch;
            state = 16;
          } else if (this.isEOL(ch)) {
            state = 23;
          } else {
            lexeme.token += ch;
          }
          break;
        case 16:
          if (this.isWord(ch)) {
            lexeme.token += ch;
            state = 15;
          } else {
            lexeme.type = LexemeType.ITALIC;
            if (ch) {
              this.ungetChar();
            }
            state = 23;
          }
          break;
        case 17:
          if (ch === '`') {
            lexeme.token += ch;
            state = 18;
          } else {
            if (ch) {
              this.ungetChar();
            }
            state = 23;
          }
          break;
        case 18:
          if (ch === '`') {
            lexeme.token += ch;
            state = 19;
          } else {
            if (ch) {
              this.ungetChar();
            }
            state = 23;
          }
          break;
        case 19:
          if (ch === '`') {
            lexeme.token += ch;
            state = 20;
          } else if (ch === '') {
            state = 23;
          } else {
            lexeme.token += ch
          }
          break;
        case 20:
          lexeme.token += ch;
          if (ch === '`') {
            state = 21;
          } else {
            state = 23;
          }
          break;
        case 21:
          lexeme.token += ch;
          if (ch === '`') {
            lexeme.type = LexemeType.CODE;
          }
          state = 23;
          break;
        case 22:
          if (ch === '*' || ch === '_' || ch === '~' || ch === '`') {
            state = 23;
            if (ch) {
              this.ungetChar();
            }
          } else if (ch === '') {
            state = 23;
          } else {
            lexeme.token += ch;
          }
          break;
        default:
          throw new Error('Invalid state!');
      }
    }

    return lexeme;
  }

  getChar(): string {
    if (this.index < this.text.length) {
      return this.text[this.index++];
    }

    return '';
  }

  ungetChar() {
    if (this.index > 0) {
      this.index--;
    }
  }

  isBlank(char: string) {
    return /^[^\w*_]?$/.test(char);
  }

  isEOL(char: string) {
    return /^[\n]?$/.test(char);
  }

  isWord(char: string) {
    return /^[A-Za-z0-9]$/.test(char);
  }
}